import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  VStack,
  HStack,
  Text,
  Icon
} from '@chakra-ui/react'
import { FaCamera } from 'react-icons/fa'

interface QRCodeScannerProps {
  isOpen: boolean
  onClose: () => void
}

export function QRCodeScanner({ isOpen, onClose }: QRCodeScannerProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent bg="#09090b" color="white" maxW="400px">
        <ModalHeader>
          <HStack align="center" gap={2}>
            <Icon as={FaCamera} color="#3182ce" />
            <Text>Control Match</Text>
          </HStack>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={8}>
          <VStack spacing={6} textAlign="center">
            <Icon as={FaCamera} w={16} h={16} color="#3182ce" />
            <Text fontSize="xl" fontWeight="bold">
              Use your device's camera
            </Text>
            <Text color="gray.400" textAlign="center">
              Open your device's camera app and scan the QR code displayed on the scoring screen to control the match.
            </Text>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
